import React, { FC } from "react";
import { withStyles, createStyles } from "@material-ui/core";

const styles = () =>
    createStyles({
        ButtonCommon: {
            borderRadius: 6,
            background: '#0256a8',
            fontFamily: 'HiraginoSans-W6',
            fontWeight: 'bold',
            textAlign: 'center',
            color: '#fff',
            fontSize: 20,
            lineHeight: '24px',
            border: 'none',
            cursor: 'pointer',
            transition: '.1s all',
            '&:hover': {
                background: '#004991 !important'
            }
        },
        ButtonCommonDisable: {
            borderRadius: 6,
            background: 'rgb(208, 208, 208)',
            fontFamily: 'HiraginoSans-W6',
            fontWeight: 'bold',
            textAlign: 'center',
            color: '#fff',
            fontSize: 20,
            lineHeight: '24px',
            border: 'none',
            cursor: 'not-allowed',
            transition: '.1s all'
        }
    });


const Button: FC<any> = ({ classes, children, ...props }) => (
  <button
    {...props}
    style={{ ...props.style }}
    className={`${props.disabled ? classes.ButtonCommonDisable : classes.ButtonCommon} ${props.className}`}
  >
    {children}
  </button>
);

export default withStyles(styles)(Button);
